/**
 * Gates the MiB plan-aware UI: locked nav badges, gated editors, and the
 * upsell takeover/modal surfaces. Front-end display gate only — backend
 * enforcement lives behind `olympus.jpcMiBCapabilities`.
 */
export const MIB_GATES_FLAG = 'hermes.jpcMiBGates'
export const MIB_CATERING_GATE_FLAG = 'hermes.jpcMiBCateringGate'
export const PRO_UPSELL_PERSONALIZED_PREVIEW_FLAG =
  'hermes.proUpsellPersonalizedPreview'

/**
 * Gates the super-admin MiB testing controls in Settings → Billing (flip
 * subscription plan + purchase type to exercise gating). Never enabled in
 * production — the flag itself is the staging gate.
 */
export const MIB_STAGING_TOOLS_FLAG = 'hermes.jpcMiBStagingTools'
